export default {
  MAILING_GROUPS: {
    RECIPIENT_TYPE: 'Zielgruppe',
    TARGET_GROUP: 'Versandoption',
  },
  SERVICE_ADVERTISEMENT: {
    SUBJECT: 'KV-Dienst Vertretung gesucht: ',
    PREAMBLE: 'wir suchen eine KV-Dienst Vertretung für den Bereich ',
    BODY: [
      'Dienstart: ',
      'Dienstort: ',
      'Dienstdauer: ',
      'Dienstbeginn: ',
      'Dienstende: ',
      'Pausezeiten: ',
      'Honorar: ',
      'Notfallscheinbeteiligung: ',
      'Die genaue leistungsabhängige Vergütung entnehmen Sie bitte dem Honorarvertrag.',
      'Achtung: Bitte besorgen Sie sich vor Dienstantritt eigenständig die Totenscheine für das jeweilige Bundesland!',
      'Ein Notdienstkoffer wird bei Bedarf gestellt.',
    ],
    FOOTER: [
      'Bei Interesse bitten wir um zeitnahe Rückmeldung oder bewerben Sie sich direkt auf unserem Marktplatz: ',
      'Sollten Sie diese E-Mails für dieses Bundesland nicht mehr bekommen wollen, können Sie Ihre Einstellungen jederzeit in Ihrem Profil anpassen: ',
    ],
  },
};
